import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import GoogleButton from "@/components/GoogleButton";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await register(form.email, form.password, form.name);
      toast.success(`Welcome, ${u.name}`);
      nav("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Registration failed");
    } finally { setBusy(false); }
  };

  const upd = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  return (
    <div data-testid="register-page" className="max-w-md mx-auto px-6 py-20">
      <div className="label-eyebrow">Join us</div>
      <h1 className="font-display text-5xl mt-3 mb-10">Create account</h1>

      <GoogleButton next="/" testId="register-google-btn" />

      <div className="flex items-center gap-3 my-8">
        <div className="flex-1 h-px bg-[#E5DFD3]" />
        <span className="text-[10px] uppercase tracking-[0.3em] text-[#5C5454]">or</span>
        <div className="flex-1 h-px bg-[#E5DFD3]" />
      </div>

      <form onSubmit={submit} className="space-y-6">
        <div>
          <label className="label-eyebrow">Name</label>
          <input data-testid="register-name" required value={form.name} onChange={upd("name")} className="mt-2 w-full bg-transparent border-b border-[#E5DFD3] py-3 focus:outline-none focus:border-[#6B1A24]" />
        </div>
        <div>
          <label className="label-eyebrow">Email</label>
          <input data-testid="register-email" type="email" required value={form.email} onChange={upd("email")} className="mt-2 w-full bg-transparent border-b border-[#E5DFD3] py-3 focus:outline-none focus:border-[#6B1A24]" />
        </div>
        <div>
          <label className="label-eyebrow">Password</label>
          <input data-testid="register-password" type="password" required minLength={6} value={form.password} onChange={upd("password")} className="mt-2 w-full bg-transparent border-b border-[#E5DFD3] py-3 focus:outline-none focus:border-[#6B1A24]" />
        </div>
        <button data-testid="register-submit" disabled={busy} className="w-full bg-[#6B1A24] text-[#FAFAF7] py-4 uppercase text-xs tracking-[0.25em] hover:bg-[#8A2532] transition-colors disabled:opacity-60">
          {busy ? "Creating…" : "Create account"}
        </button>
      </form>
      <p className="mt-8 text-sm text-[#5C5454]">
        Have an account? <Link to="/login" data-testid="register-to-login" className="text-[#6B1A24] underline underline-offset-4">Sign in</Link>
      </p>
    </div>
  );
}
